import posthog from 'posthog-js'

// Must match the Data Processing Service name configured in Usercentrics.
const POSTHOG_DPS = 'PostHog'

// Relay the Usercentrics consent decision to PostHog. Consent model is opt-out
// (MSPL / US): PostHog captures by default and opts out when the PostHog service
// is denied (or the visitor signals GPC / Do Not Track).
async function applyConsent() {
  const cmp = (window as any).__ucCmp
  if (!cmp?.getConsentDetails) return
  const details = await cmp.getConsentDetails()
  const service = Object.values(details?.services ?? {}).find(
    (svc: any) => svc.name === POSTHOG_DPS,
  ) as any
  if (service?.consent?.given) {
    posthog.opt_in_capturing()
  } else {
    posthog.opt_out_capturing()
  }
}

function wireConsentRelay() {
  if ((window as any).__ucConsentWired) return
  ;(window as any).__ucConsentWired = true

  window.addEventListener('UC_UI_CMP_EVENT', () => {
    applyConsent()
  })

  const ready = setInterval(() => {
    if ((window as any).__ucCmp?.getConsentDetails) {
      clearInterval(ready)
      applyConsent()
    }
  }, 200)
  setTimeout(() => clearInterval(ready), 15000)
}

export const usePostHog = () => {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    // Opt-out model: on by default, but start opted-out when the visitor signals
    // GPC / Do Not Track.
    opt_out_capturing_by_default:
      (navigator as any).globalPrivacyControl === true ||
      navigator.doNotTrack === '1',
    respect_dnt: true,
    loaded: function (ph) {
      if (import.meta.env.VITE_ENVIRONMENT == 'development') {
        ph.opt_out_capturing()
        ph.set_config({ disable_session_recording: true })
      }
    },
  })

  wireConsentRelay()

  return {
    posthog,
  }
}
